import React from "react";
import { NavLink } from "react-router-dom";
import { BsFileEarmarkPdfFill, BsGridFill } from "react-icons/bs";
import { MdSettingsSuggest } from "react-icons/md";

const AdminRoutes = [
	{
		label: "Dashboard",
		path: "/admin/dashboard",
		icon: <BsGridFill />,
	},
	{
		label: "Sujets",
		path: "/admin/sujets",
		icon: <BsFileEarmarkPdfFill />,
	},
	{
		label: "Paramètres",
		path: "/admin/parametres",
		icon: <MdSettingsSuggest />,
	},
];

const AdminSidebar = () => {
	return (
		<div className="bg-white shadow-md w-1/6 flex flex-col items-center py-5">
			<div className="text-4xl font-lobster  flex justify-between">
				<NavLink to="/">
					<span className="text-slate-900">Gandal</span>
				</NavLink>
			</div>
			<ul className="mt-10">
				{AdminRoutes?.map((route) => (
					<li className="mb-4" key={route.label}>
						<NavLink
							to={route.path}
							className={({ isActive }) =>
								`sidebar-link font-bold ${
									isActive && "text-orange-500"
								}`
							}
						>
							<span>{route.icon}</span>
							<span>{route.label}</span>
						</NavLink>
					</li>
				))}
			</ul>
		</div>
	);
};

export default AdminSidebar;
